import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsOverviewRoute: InvariantJiraRoute = {
	name: 'software-reports',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports',
	query: ['dashboardId?'],
};
